import * as d3 from 'd3';
import { wrapLongLabels } from './utils/helpers';
import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    width,
    height,
    initialWidth,
    initialHeight,
    data,
    margins,
    x,
    xAxis,
    y,
    yAxis,
    colorScale,
  } = props;

  const xTicks = isMobile ? 1 : 1;
  const [min] = x.domain();

  // legend
  container.append('ul')
    .attr('class', 'key')
    .selectAll('li')
    .data(colorScale.domain())
    .enter()
    .append('li')
    .attr('class', 'key-item')
    .html(d => `<span class='key-block' style='background-color:${colorScale(d)};'></span>${d.replace(/_/g, ' ')}`);

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const newLeftMargin = 10; // or a smaller number if you want a little padding
  const g = svg.append('g')
    .attr('transform', `translate(${[newLeftMargin, margins.top]})`);

  const xGrid = g.append('g')
    .attr('class', 'x grid')
    .attr('transform', `translate(${[0, height]})`)
    .call(xAxis(x).ticks(xTicks).tickFormat(d => d3.format('.0%')(d / 100)).tickSize(-height));

  xGrid.selectAll('text')
    .attr('y', 10);

  const yGrid = g.append('g')
    .attr('class', 'y grid')
    .call(yAxis(y));

  yGrid.selectAll('text').remove();

  const group = g.append('g')
    .attr('class', 'data');

  const serie = group.selectAll('g')
    .data(data)
    .enter().append('g')
    .style('fill', d => colorScale(d.key))
    .selectAll('g')
    .data(d => d)
    .enter()
    .append('g')
    .attr('class', 'serie')
    .attr('transform', d => `translate(${[x(d[0]), y(d.data.label)]})`);

  serie.append('rect')
    .attr('width', d => x(d[1]) - x(d[0]))
    .attr('height', y.bandwidth());

  const text = serie.filter((d) => {
    const x0 = x(d[1]) - x(d[0]);
    const breakpoint = isMobile ? 0.2 : 0.05;
    return x0 > width * breakpoint;
  });

  text.append('text')
    .attr('class', 'value')
    .attr('x', d => (d[1] < 0 ? 0 : x(d[1]) - x(d[0])))
    .attr('y', y.bandwidth() / 2)
    .attr('dx', d => (d[1] < 0 ? 5 : -5))
    .attr('dy', '.35em')
    .attr('text-anchor', d => (d[1] < 0 ? 'start' : 'end'))
    .text(d => d3.format('.0%')((d[1] - d[0]) / 100));

  if (min < 0) {
    g.append('line')
      .attr('class', 'zero-bar')
      .attr('x1', x(0))
      .attr('x2', x(0))
      .attr('y1', 0)
      .attr('y2', height);
  }
}
